package com.ijoin.platform

import kotlinx.datetime.Instant
import kotlin.time.Clock

actual fun currentInstant(): Instant = Clock.System.now()
